import { render, staticRenderFns } from "./AddKpi.vue?vue&type=template&id=9957602c&"
import script from "./AddKpi.vue?vue&type=script&lang=js&"
export * from "./AddKpi.vue?vue&type=script&lang=js&"
import style0 from "./AddKpi.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports